import React, { useEffect, useState } from "react";
import { Clock } from "lucide-react";

// 7 days from the first time a visitor sees the site, persisted in localStorage.
const LS_KEY = "vyron_launch_deadline";
const DURATION_MS = 7 * 24 * 60 * 60 * 1000;

function getDeadline() {
  try {
    const raw = localStorage.getItem(LS_KEY);
    if (raw) {
      const t = parseInt(raw, 10);
      if (!Number.isNaN(t) && t > Date.now()) return t;
    }
  } catch (e) { /* ignore storage errors */ }
  const t = Date.now() + DURATION_MS;
  try { localStorage.setItem(LS_KEY, String(t)); } catch (e) { /* ignore */ }
  return t;
}

function fmt(n) { return String(n).padStart(2, "0"); }

export const LaunchCountdown = ({ testid = "launch-countdown", compact = false }) => {
  const [deadline] = useState(() => (typeof window === "undefined" ? Date.now() + DURATION_MS : getDeadline()));
  const [now, setNow] = useState(Date.now());

  useEffect(() => {
    const id = setInterval(() => setNow(Date.now()), 1000);
    return () => clearInterval(id);
  }, []);

  const diff = Math.max(0, deadline - now);
  const days = Math.floor(diff / (24 * 60 * 60 * 1000));
  const hours = Math.floor((diff % (24 * 60 * 60 * 1000)) / (60 * 60 * 1000));
  const minutes = Math.floor((diff % (60 * 60 * 1000)) / (60 * 1000));
  const seconds = Math.floor((diff % (60 * 1000)) / 1000);

  const cells = [
    { l: "Days", v: fmt(days) },
    { l: "Hours", v: fmt(hours) },
    { l: "Min", v: fmt(minutes) },
    { l: "Sec", v: fmt(seconds) },
  ];

  return (
    <div data-testid={testid} className={`rounded-2xl border border-gold/40 bg-black text-white ${compact ? "px-4 py-3" : "px-5 py-4"}`}>
      <div className="flex items-center gap-2 mb-2">
        <Clock size={14} className="text-gold" />
        <span className="text-[10px] uppercase tracking-[0.28em] text-gold">Launch Offer Ending Soon</span>
      </div>
      <div className="flex items-center gap-2 md:gap-3">
        {cells.map((c, i) => (
          <React.Fragment key={c.l}>
            <div className="flex-1 text-center">
              <div className="font-display text-2xl md:text-3xl tracking-tight tabular-nums">{c.v}</div>
              <div className="text-[9px] uppercase tracking-[0.2em] text-white/50 mt-0.5">{c.l}</div>
            </div>
            {i < cells.length - 1 && <span className="text-gold/60 text-lg -mt-3">:</span>}
          </React.Fragment>
        ))}
      </div>
    </div>
  );
};

export default LaunchCountdown;
